import React from 'react';

/**
 * AM / PM session chip — design-system attendance session colours + shape.
 *
 * DS (design-system-reference.md § Attendance Table Color Scheme → AM / PM Session Chips):
 *   AM → bg-sky-100 text-sky-700
 *   PM → bg-slate-200 text-slate-700
 *
 * Shape matches the attendance-table / leave-period chip convention used by
 * Adjust & Lock and LeavePeriodDisplay: pill (`rounded-full`), 11px, py-px.
 *
 * Returns null when session is missing or Full Day (chip = half-day signal only).
 *
 * @param {Object} props
 * @param {'AM'|'PM'|'Full Day'|string|null|undefined} props.session
 * @param {string} [props.className]
 */
export const SessionPeriodChip = ({ session, className = '' }) => {
  if (!session || session === 'Full Day') return null;

  const normalized = String(session).trim().toUpperCase();
  if (normalized !== 'AM' && normalized !== 'PM') return null;

  const colorClasses =
    normalized === 'AM'
      ? 'bg-sky-100 text-sky-700'
      : 'bg-slate-200 text-slate-700';

  return (
    <span
      className={`inline-flex items-center px-1.5 py-px rounded-full text-[11px] font-semibold ${colorClasses} ${className}`.trim()}
    >
      {normalized}
    </span>
  );
};

export default SessionPeriodChip;
